import React, { FC } from 'react';
import styled from 'styled-components';

import { Link } from 'components/Common';
import { FontIcon } from './FontIcon';

const StyledSearchIcon = styled(FontIcon)`
  margin-right: 20px;
  display: inline-block;
  cursor: pointer;
  color: var(--sys-color--on-surface);
`;

interface SearchButtonProps {
}

export const SearchButton: FC<SearchButtonProps> = () => {
  return (
    <Link
      to={`/v2/search`}
      pageDirection="FORWARD"
    >
      <StyledSearchIcon name="search" size={24} aria-label="search-icon" id="search-icon" />
    </Link>
  );
};